/** PURE_IMPORTS_START _noop PURE_IMPORTS_END */
import { noop } from './noop';
/* tslint:enable:max-line-length */
export function pipe() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return pipeFromArray(fns);
}
/* @internal */
export function pipeFromArray(fns) {
    if (!fns) {
        return noop;
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
    };
}
//# sourceMappingURL=pipe.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/util/pipe.js
// module id = 67
// module chunks = 1